module.exports = __webpack_public_path__ + "static/img/m_name.70d8f08.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/yzzzbq/m_name.png
// module id = FTlV
// module chunks = 7